exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".denomination-create-form-style .denom-ui-section {\n  display: flex;\n  justify-content: space-between; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/denomination/create/denomination.create.scss
// module id = 1142
// module chunks = 1